<template lang="pug">
v-container(fluid :class="loading ? 'tw-opacity-50' : ''" class=" tw-border tw-rounded-md tw-border-gray-lighten-3 tw-mb-2")
  v-row(align="center" no-gutters)
    v-col(cols="auto")
      div(class=" tw-bg-gray-lighten-3 pa-3 tw-rounded ")
        v-icon mdi-office-building
    v-col(class="tw-mx-2")
      v-row(dense)
        v-col
          span(class="tw-font-bold ") {{ item.name }}
      v-row(dense)
        v-col
          span(class=" tw-text-gray-darken-1") {{ item.address_street }}, {{ item.address_city }}
    v-col(cols="auto")
      v-menu(
        bottom
        left
        nudge-bottom="35"
        nudge-left="5"
        ma-0
        pa-0
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            :ripple="false"
            depressed
            v-on="on"
            v-bind="attrs"
            width="10px"
            max-width="10"
            min-width="10"
            min-height="10"
            max-height="30"
            :disabled="loading"
            class="tw-border-gray-lighten-1 tw-p-0 tw-m-0"
          )
            v-icon(color="blue-grey darken-1 tw-p-0 tw-m-0") mdi-dots-horizontal
        v-list(dark dense min-width="120px" style="background-color: #424242")
          v-list-item(class="tw-p-0")
            v-btn(
              small
              left
              tile
              block
              pa-0
              ma-0
              text
              @click="$emit('edit', item)"
              class="tw-items-center tw-justify-start tw-my-1"
            ) {{ $t('Common.edit') }}
          v-list-item(class="tw-p-0")
            v-btn(
              small
              left
              tile
              block
              pa-0
              ma-0
              text
              @click="destroy"
              class=" tw-items-center tw-justify-start tw-my-1"
            ) {{ $t('Common.delete') }}
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    destroy() {
      this.loading = true;
      this.$store
        .dispatch('offices/delete', this.item.id)
        .then((response) => {
          this.$store
            .dispatch('offices/list')
            .then((response) => {
              this.loading = false;
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
